export default __webpack_public_path__ + "static/media/thumbnail.c7e2f8f6.png";